<template>
  <b-modal
    size="lg"
    :id="'modal-transactions'+ order"
    :title="'Historial de Transacciones de la orden ' + order"
    ok-only
    hide-footer
  >
    <b-row>
      <b-col class="col-md-12">
        <b-card v-if="orderTransaction.length">
          <b-card-body>
            <b-table
              :items="orderTransaction"
              :fields="fields"
              bordered
              responsive
              small
            />
          </b-card-body>
        </b-card>
        <b-card v-else>
          <b-alert show variant="danger">
            <div class="alert-body text-center"> <span>Esta orden no tiene transacciones realizadas</span></div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { toCurrency } from '@/helpers/helpers';


export default {
  props:{
    orderTransaction:{
      type: Array,
      required: true,
      default: []
    },
    order:{
      type: Number,
      default: ''
    }
  },
  data(){
    return {
      fields: [
        {key: 'date' , label: 'Fecha de pago'},
        {key: 'amount' , label: 'Importe', formatter: (value, key, item) =>{
          return toCurrency(item.amount, item.currency)
        }},
        {key: 'pasarela' , label: 'Pasarela'},
        {key: 'bankR' , label: 'Autorización'},
        {key: 'card' , label: 'Cuenta bancaria'},
        {key: 'status' , label: 'Estado'}
      ],
    }
  },
}
</script>